export default "__VITE_ASSET__CFWR3qQT__"